import { useState } from "react";

export default function InputTextField({
	label,
    type, 
    name,
    value, 
    placeholder, 
    disabled, 
    required,
    onChange,
    labelRequire=true,
	className=""
}) {
	/* focus handler - styles css */
    const [isFocused, setIsFocused] = useState(false);

    /* error handler - styles css */
    const [isEmpty, setIsEmpty] = useState(false);

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = (e) => {
        setIsFocused(false);
        setIsEmpty(!!required && !e.target.value);
    };

	const computedClassName = className || (disabled ? "inputTextField__containerInput--disabled" : "inputTextField__containerInput--input");
	
	const inputTextFieldContent = (
		<div className={`inputTextField__containerInput ${className}`}>
			<input 
				id={name}
				type={type}
				name={name}
				value={value}
				placeholder={required ? `${placeholder}` : placeholder}
				disabled={disabled}
				required={required}
				onChange={onChange}
				onFocus={handleFocus}
				onBlur={handleBlur}
				className={`inputTextField__containerInput ${computedClassName}`}
			/>
		</div>
	);
  return (
		<>
    		<div>
				<div className={`inputTextField__content ${isFocused ? "inputTextField__content--focused" : "" } ${isEmpty ? "inputTextField__content--error" : ""}`}>
					{label ? (
						<label 
							htmlFor={name}
							className={`inputTextField__content--label ${isFocused ? "inputTextField__content--label--focused" : ""} ${isEmpty ? "inputTextField__content--label--error" : ""}`}
						>
								{required ? label + '*' : label}
						</label>
					) : null}                        
					{inputTextFieldContent}                        
				</div>
				{(required && labelRequire) &&(
					<div className="inputTextField__required">
						<span className={`inputTextField__required--textRequired ${isEmpty ? "inputTextField__required--textRequired--error" : ""}`}>*Requis</span>
					</div>
				)}
			</div>
		</>
  )
}
